import {
  IGetApplicationsParams,
  IGetApplicationsRes,
  IApproveTeacherApplicationReq,
  IRejectTeacherApplicationReq,
  IGetTeacherDemoAttemptsParams,
  IGetTeacherDemoAttemptsRes,
  IReviewTeacherDemoReq,
  ITeacherDemoDetail,
} from '~/types/teacher-application'
import http from '~/utils/http'

/** 获取教师申请列表 */
export function getTeacherApplications(params: IGetApplicationsParams = {}) {
  const { page = 1, size = 20, status } = params
  return http.get<IGetApplicationsRes>('/admin/teacher-application', {
    params: {
      page,
      size,
      status: status || 'ALL',
    },
  })
}

/** 审核通过教师申请 */
export function approveTeacherApplication(id: string, data: IApproveTeacherApplicationReq) {
  return http.post(`/admin/teacher-application/${id}/approve`, data)
}

/** 拒绝教师申请 */
export function rejectTeacherApplication(id: string, data: IRejectTeacherApplicationReq) {
  return http.post(`/admin/teacher-application/${id}/reject`, data)
}

/** 获取现场 Demo 课堂审核队列 */
export function getTeacherDemoAttempts(params: IGetTeacherDemoAttemptsParams = {}) {
  const { page = 1, size = 20, status } = params
  return http.get<IGetTeacherDemoAttemptsRes>('/admin/teacher-demo', {
    params: {
      page,
      size,
      status: status || 'UNDER_REVIEW',
    },
  })
}

/** 获取一次 Demo 课堂的脚本、录像和审核信息 */
export function getTeacherDemoAttempt(id: string) {
  return http.get<ITeacherDemoDetail>(`/admin/teacher-demo/${id}`)
}

/** Demo 二审通过，老师正式启用 */
export function approveTeacherDemo(id: string, data: IReviewTeacherDemoReq) {
  return http.post(`/admin/teacher-demo/${id}/approve`, data)
}

/** Demo 二审最终拒绝；当前产品不支持重新提交 */
export function rejectTeacherDemo(id: string, data: Required<IReviewTeacherDemoReq>) {
  return http.post(`/admin/teacher-demo/${id}/reject`, data)
}
